/**
 * Перепроверка F35 — «ответ = обработано» гасит только то, что менеджер
 * ВИДЕЛ. Каждый вызов `sendSlackMessage` / `sendGmailReply` несёт
 * `seenMessageId`: id самого нового ВХОДЯЩЕГО сообщения, показанного в
 * открытом треде в момент «Отправить». Сервер помечает прочитанным и
 * обработанным входящее до него; пришедшее, пока писался ответ, остаётся
 * ждать. Без него сервер гасит всё до ответа — так было раньше.
 *
 * Лента любого треда в ERP — старые сверху, новые снизу (`.reverse()` над
 * страницей keyset), поэтому ищем с конца.
 */
export interface ISeenCandidate {
  id: string;
  direction?: string | null;
}

export const INBOUND_DIRECTION = 'inbound';

/** id самого нового входящего в ленте (старые → новые); `null` — входящих нет. */
export const newestInboundId = (
  messages: ReadonlyArray<ISeenCandidate | null | undefined>,
): string | null => {
  for (let index = messages.length - 1; index >= 0; index -= 1) {
    const message = messages[index];
    if (message && message.direction === INBOUND_DIRECTION && message.id) {
      return String(message.id);
    }
  }
  return null;
};
